<template>
  <div class="component-wrapper d-flex flex-column align-center">
    <Breadcrumb class="breadcrumb mb-8" :breadcrumbItems="breadCrumbItems" />

    <div v-if="hasErrors == false">
      <Alert :items="alertSuccessItems" class="mb-4"> </Alert>

      <v-simple-table class="table mb-16">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-sm-body-1 font-weight-bold">Κεφάλαιο</th>
              <th class="text-sm-body-1 font-weight-bold">Διάστημα</th>

              <th class="text-sm-body-1 font-weight-bold">Έτος</th>
              <th class="text-sm-body-1 font-weight-bold">Κατάσταση</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fund, i) in fundsXML" :key="i">
              <td class="text-sm-body-1">
                {{ fund.fundId }}
              </td>

              <td class="text-sm-body-1">
                {{ fund.reportPeriodId }}
              </td>

              <td class="text-sm-body-1">
                {{ fund.year }}
              </td>

              <td class="text-sm-body-1">
                {{ fund.status }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div class="d-flex justify-center">
        <v-btn
          class="mr-10 success rounded text-sm-body-1 font-weight-regular"
          @click="onSubmit"
          :loading="loader"
          >Υποβολή</v-btn
        >
        <v-btn
          to="/employees/"
          class="secondary rounded text-sm-body-1 font-weight-regular"
          >Επιστροφή</v-btn
        >
      </div>
    </div>

    <div v-else-if="hasErrors == true">
      <Alert :items="alertErrorItems" class="mb-4"> </Alert>

      <v-data-table
        :headers="xmlErrorsHeaders"
        :items="reportErrors"
        :single-expand="false"
        :expanded.sync="expanded"
        item-key="uid"
        show-expand
        class="elevation-1 mb-sm-16 mb-8 table"
        :hide-default-footer="true"
        :items-per-page="-1"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-2">{{ item.message }}</td>
        </template>
      </v-data-table>

      <div class="d-flex flex-sm-row flex-column justify-center align-center">
        <v-btn
          class="
            mr-sm-10
            mb-sm-0 mb-2
            success
            rounded
            text-sm-body-1
            font-weight-regular
            button
          "
          @click="onExport"
          >Εξαγωγή σφαλμάτων σε αρχείο</v-btn
        >
        <v-btn
          @click="onReturn"
          class="secondary rounded text-sm-body-1 font-weight-regular button"
          >Επιστροφή</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "../../components/Alert.vue";
import Breadcrumb from "../../components/Breadcrumb.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    Alert,
    Breadcrumb,
  },

  created() {
    if (this.route == "new") {
      this.breadCrumbItems[1] = {
        text: "Νέα έκθεση",
        disabled: false,
        to: "/employees/new/report",
      };
      this.breadCrumbItems[2] = {
        text: "Αποτέλεσμα επαλήθευσης",
        disabled: true,
        to: "/employees/new/validation",
      };
    } else {
      this.breadCrumbItems[1] = {
        text: `Νέα έκδοση`,
        disabled: false,
        to: `/employees/${this.currentReport.reportId}/update_report`,
      };
      this.breadCrumbItems[2] = {
        text: `Αποτέλεσμα επαλήθευσης`,
        disabled: true,
        to: `/employees/report/${this.currentReport.reportId}/validation`,
      };
    }
  },

  data() {
    return {
      result: 2,
      loader: false,
      expanded: [],
      singleExpand: false,
      xmlErrorsHeaders: [
        {
          text: "ID",

          sortable: false,
          value: "id",
        },

        {
          text: "Μήνυμα ESMA",
          sortable: false,
          value: "esmamessage",
        },

        {
          text: "Γραμμή Σφάλματος",
          sortable: false,
          value: "line",
        },

        {
          text: "Γραμμή Σύγκρισης",
          sortable: false,
          value: "lineToCompare",
        },
        { text: "", value: "data-table-expand" },
      ],

      alertErrorItems: {
        strong_text: "Το αρχείο της έκθεσης έχει σφάλματα. ",
        text: "Παρακαλώ διορθώστε τα και υποβάλετε ξανά την έκθεση.",
        text_color: "error",
        dismissable: false,
        width: "950px",
      },

      alertSuccessItems: {
        strong_text: "Επιτυχής επαλήθευση της έκθεσης!  ",
        text:
          "Αφού βεβαιωθείτε για τα κεφάλαια και τις περιόδους υποβολής, μπορείτε να προχωρήσετε σε υποβολή.",
        text_color: "success",
        dismissable: false,
        width: "950px",
      },

      breadCrumbItems: [
        {
          text: "Αρχική",
          disabled: false,
          to: "/employess",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      reportErrors: (state) => state.reports.uploadedReport.xmlErrors,
      fundsXML: (state) => state.reports.uploadedReport.fundsXML,
      errorSummaryPath: (state) =>
        state.reports.uploadedReport.errorSummaryPath,
      reportVersionId: (state) => state.reports.uploadedReport.reportVersionId,
      currentReport: (state) => state.reports.currentReport,
      route: (state) => state.reports.currentRoute,
      xmlErrors: (state) => state.reports.xmlErrors,
    }),

    ...mapGetters(["hasErrors"]),
  },

  methods: {
    ...mapActions(["getXmlErrors", "submitReport"]),
    async onExport() {
      try {
        await this.getXmlErrors(this.errorSummaryPath);

        const url = window.URL.createObjectURL(new Blob([this.xmlErrors]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "errors");
        document.body.appendChild(link);
        link.click();
      } catch {}
    },

    onReturn() {
      if (this.route == "new") this.$router.push(`/employees/new/report`);
      else {
        this.$router.push(
          `/employees/${this.currentReport.reportId}/update_report`
        );
      }
    },

    async onSubmit() {
      try {
        this.loader = true;
        await this.submitReport(this.reportVersionId);
        this.loader = false;
        this.$router.push("/employees");
      } catch {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb,
.table {
  width: 950px; /*  idio width me tou history component  */
}

@media only screen and (max-width: 960px) {
  .breadcrumb,
  .table {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .button {
    width: 280px;
  }
}
</style>
